import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import * as moment from "moment";
import * as uuid from "uuid";
import * as angular from "angular";

import { ReportService } from "../../services/report-service";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { ContractService } from "../../services/contract-service";
import { StorageService } from "../../services/storage-service";
import { RightsFilterService } from "assets/app/services/rights-filter-service";

export class CatalogAvailabilityController {
    static $inject = ["$scope", "$filter", "reportService", "notifyService", "entityService", "contractService", "rightsFilterService"];

    filterModel: Models.IRightsFilterModel;
    rows: Models.ICatalogAvailsDocument[];
    selectedRows: Models.ICatalogAvailsDocument[];
    allSelected: boolean;
    selectedProperties: number[];
    worksheetPage: number;
    worksheetCount: number;
    prevQuery: any;
    recordIDs: number[];
    worksheetLoading: boolean;
    worksheetPageCount: number;
    salesSheetTitle: string;

    transactionID: string;
    saving: boolean;
    showModal: boolean;
    saveTimedOut: boolean;
    // "salessheet" or "collection"
    saveMode: string;

    exportUrl: string;
    showExport: boolean;
    pagingOptions: Models.IPagingOptions;
    pageCount: number;
    numFound: number;
    loading: boolean;
    titleQuery: string;

    constructor(
        private $scope: ng.IScope,
        private $filter: ng.IFilterService,
        private reportService: ReportService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private contractService: ContractService,
        private rightsFilterService: RightsFilterService) {


        this.exportUrl = "/api/report/ExportAvailabilityProperties";

        this.selectedRows = [];
        this.selectedProperties = [];
        this.allSelected = false;
        this.worksheetCount = 0;
        this.worksheetPage = 1;
        this.recordIDs = [];
        this.worksheetLoading = false;
        this.worksheetPageCount = 1;
        this.salesSheetTitle = "";
        this.saving = false;
        this.showModal = false;

        this.showExport = false;
        this.saveMode = "salessheet";
        this.loading = false;
        this.rows = [];

        this.pagingOptions = {
            rows: 20,
            page: 1
        }

        this.SetupParameters();

        $scope.$watch(() => this.pagingOptions.page, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.Search(false);
            }
        });

        $scope.$watch(() => this.worksheetPage, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.SearchWorksheet();
            }
        });

        $scope.$watch(() => this.selectedProperties, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (newValue.length == this.pagingOptions.rows) {
                    this.worksheetPage = 1;
                }
            }
        }, true);
    }

    ResultsHasSelection() {
        var rows = <Models.ICatalogAvailsDocument[]>this.rows;
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].selected) return true;
        }

        return false;
    }

    WorksheetHasSelection() {
        for (var i = 0; i < this.selectedRows.length; i++) {
            if (this.selectedRows[i].selected) return true;
        }

        return false;
    }

    StartSave() {
        if (this.saveMode == 'salessheet') {
            this.SaveSalesSheet();
        } else if (this.saveMode == 'collection') {
            this.SaveCatalog();
        }
    }

    GetQueryString(object: any) {
        var queryString = "";
        for (var key in object) {

            var value = "";
            var objValue = object[key];
            if (objValue == undefined || _.isNaN(objValue)) {
                value = "";
            } else if (_.isArray(objValue)) {
                value = object[key];
            } else if (_.isObject(objValue)) {
                value = JSON.stringify(objValue);
            } else {
                value = objValue;
            }

            if (queryString == "") {
                queryString += "?" + key + "=" + value;
            }
            else {
                queryString += "&" + key + "=" + value;
            }
        }
        return queryString;
    }

    SaveCatalog() {
        this.saving = true;
        this.notifyService.startProgress();

        this.entityService.createEntityAndRelationships(Consts.CharTypeIDs.property, 5, this.salesSheetTitle, Consts.CharTypeIDs.property, this.selectedProperties)
            .then((result) => {
                this.saveTimedOut = false;
                this.transactionID = result.entityID;
            })
            .catch((result) => {
                this.saveTimedOut = true;
            })
            .finally(() => {
                this.saving = false;
                this.salesSheetTitle = '';
                this.showModal = true;
                this.notifyService.endProgress();
            });
    }

    SaveSalesSheet() {
        this.saving = true;
        this.notifyService.startProgress();
        var query: Models.ICreateSalesSheetRequest = {
            templateRecordID: 4,
            title: this.salesSheetTitle,
            rightSet: {
                templateID: 8,
                startDate: new Date(this.filterModel.startDate),
                endDate: new Date(this.filterModel.endDate),
                territoryIDs: this.filterModel.selectedTerritoryIDs,
                mediaIDs: this.filterModel.selectedMediaIDs
            },
            assetIDs: this.selectedProperties
        }

        this.contractService.saveSalesSheet(query)
            .then((result) => {
                this.saveTimedOut = false;
                this.transactionID = result.entityID;
            })
            .catch((result) => {
                this.saveTimedOut = true;
            })
            .finally(() => {
                this.saving = false;
                this.salesSheetTitle = '';
                this.showModal = true;
                this.notifyService.endProgress();
            });
    }

    SearchWorksheet() {
        var recordIDs = this.selectedProperties.slice((this.worksheetPage - 1) * this.pagingOptions.rows, (this.worksheetPage - 1) * this.pagingOptions.rows + this.pagingOptions.rows);

        this.worksheetLoading = true;
        this.notifyService.startProgress();
        this.reportService.getAvailabilityWindowProperties(_.parseInt(this.filterModel.exactInd),
            _.parseInt(this.filterModel.exclusive) || 1,
            this.filterModel.isWindowed,
            this.filterModel.startDate,
            this.filterModel.endDate,
            this.filterModel.selectedTerritoryIDs,
            this.filterModel.selectedMediaIDs,
            this.filterModel.selectedChannelIDs,
            this.filterModel.selectedLanguageIDs,
            this.titleQuery,
            recordIDs,
            this.filterModel.selectedAssetFacet,
            this.pagingOptions.page,
            this.pagingOptions.rows,
            this.filterModel.rollup)
            .then((result: any) => {
                this.selectedRows = <Models.ICatalogAvailsDocument[]>result.resultDocs;
            })
            .finally(() => {
                this.notifyService.endProgress();
                this.worksheetLoading = false;
            });
    }

    Reset() {
        this.selectedProperties = [];
        this.selectedRows = [];
    }

    RemoveSelections() {
        var i = this.selectedRows.length;
        while (i--) {
            var row = this.selectedRows[i];
            if (row.selected) {
                row.selected = false;
                this.selectedRows.splice(i, 1);
                this.selectedProperties.splice(this.selectedProperties.indexOf(row.recordID), 1);
            }
        }
    }

    AddProperties() {
        var rows = <Models.ICatalogAvailsDocument[]>this.rows;

        if (this.allSelected) {
            this.reportService.getCatalogAvailsIDs(_.parseInt(this.filterModel.exactInd),
                _.parseInt(this.filterModel.exclusive) || 1,
                this.filterModel.isWindowed,
                this.filterModel.startDate,
                this.filterModel.endDate,
                this.filterModel.selectedTerritoryIDs,
                this.filterModel.selectedMediaIDs,
                this.filterModel.selectedChannelIDs,
                this.filterModel.selectedLanguageIDs,
                this.titleQuery,
                this.filterModel.selectedAssetRecordIDs,
                this.filterModel.selectedAssetFacet,
                this.pagingOptions.page,
                this.pagingOptions.rows,
                this.filterModel.rollup)
                .then((result) => {
                    this.selectedProperties = result;
                    this.worksheetPageCount = Math.ceil(result.length / this.pagingOptions.rows);
                });
        }

        for (var i = 0; i < rows.length; i++) {
            if (rows[i].selected) {
                rows[i].selected = false;

                if (this.selectedProperties.indexOf(rows[i].recordID) == -1) {
                    this.selectedProperties.push(rows[i].recordID);
                    this.selectedRows.splice(0, 0, rows[i]);
                }
            }
        }

        if (this.selectedRows.length > this.pagingOptions.rows) {
            this.selectedRows.splice(this.pagingOptions.rows, this.selectedRows.length);
        }

        if (!this.allSelected) {
            this.worksheetPageCount = Math.ceil(this.selectedProperties.length / this.pagingOptions.rows);
        }
    }

    SelectProperties(pageOnly: boolean, select: boolean) {
        if (!pageOnly) {
            this.allSelected = true;
            for (var i = 0; i < this.rows.length; i++) {
                var item = <Models.ICatalogAvailsDocument>this.rows[i];
                item.selected = select;
            }
        }
        else {
            this.allSelected = false;
            var length = this.pagingOptions.page * this.pagingOptions.rows;
            for (var i = 0; i < (length >= this.rows.length ? this.rows.length : length); i++) {
                var item = <Models.ICatalogAvailsDocument>this.rows[i];
                item.selected = select;
            }
        }
    }


    SetupParameters() {
        // start date defaults to today
        var startDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .format("L");
        // end date defaults to a year after today
        var endDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .add(moment.duration({ 'years': 1 }))
            .format("L");

        this.filterModel = this.rightsFilterService.GetCachedFilter({
            startDate: startDate,
            endDate: endDate,
            exactInd: "0",
            exclusive: "1",
            selectedChannelIDs: [],
            selectedAssetFacet: {},
            selectedLanguageIDs: [],
            selectedMediaIDs: [],
            selectedTerritoryIDs: [],
            selectedRightSetTemplateIDs: [],
            show: {},
            rollup: 0,
            selectedAssetRecordIDs: [],
            dimFormat: { "1": true, "2": true, "3": true, "4": true }
        });
    }

    GetExportUrl() {
        var query = {
            mode: _.parseInt(this.filterModel.exactInd),
            startDate: this.filterModel.startDate,
            endDate: this.filterModel.endDate,
            territoryIds: this.filterModel.selectedTerritoryIDs,
            mediaIds: this.filterModel.selectedMediaIDs,
            channelIds: this.filterModel.selectedChannelIDs,
            languageIds: this.filterModel.selectedLanguageIDs,
            templateIds: "",
            exclusive: _.parseInt(this.filterModel.exclusive) || 1,
            propertyIDs: this.filterModel.selectedAssetRecordIDs,
            assetFacets: this.filterModel.selectedAssetFacet,
            rollup: this.filterModel.rollup
        };

        var url = this.exportUrl;
        url += this.GetQueryString(query);

        return url;
    }

    Search(resetPage: boolean = true) {
        this.rows = [];
        this.loading = true;
        this.notifyService.startProgress();

        if (resetPage) {
            this.pagingOptions.page = 1;
        }

        this.reportService.getAvailabilityWindowProperties(
            _.parseInt(this.filterModel.exactInd),
            _.parseInt(this.filterModel.exclusive) || 1,
            this.filterModel.isWindowed,
            this.filterModel.startDate,
            this.filterModel.endDate,
            this.filterModel.selectedTerritoryIDs,
            this.filterModel.selectedMediaIDs,
            this.filterModel.selectedChannelIDs,
            this.filterModel.selectedLanguageIDs,
            this.titleQuery,
            this.filterModel.selectedAssetRecordIDs,
            this.filterModel.selectedAssetFacet,
            this.pagingOptions.page,
            this.pagingOptions.rows,
            this.filterModel.rollup)
            .then((result: any) => {
                this.pagingOptions.page = result.page;
                this.rows = <Models.ICatalogAvailsDocument[]>result.resultDocs;
                this.pageCount = result.pageCount;
                this.numFound = result.numFound;
            })
            .finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
    }
}


export class CatalogAvailsReportController {

    static $inject = ["$scope", "$filter", "$timeout", "$window", "$q", "reportService", "notifyService", "entityService", "contractService", "storage", "rightsFilterService"];

    filterModel: Models.IRightsFilterModel;
    rows: Models.IEntitySearchDoc[];
    loading: boolean;
    searchPage: number;
    searchFrom: number;
    searchTo: number;
    searchTotal: number;
    searchPageCount: number;
    searchPageSize: number = 25;
    searchSortField: string;
    searchSortDir: number;

    worksheetIDKey: string = Consts.userDivAppUrlHash + "_catalog_avails_worksheet_id";
    worksheetID: string;


    selectedRows: Models.IEntitySearchDoc[];
    selectedAssetIDs: { [assetID: number]: boolean };
    searchAllSelected: boolean;

    worksheetRows: Models.IEntitySearchDoc[];
    selectedWorksheetRows: Models.IEntitySearchDoc[];
    selectedWorksheetAssetIDs: { [assetID: number]: boolean };

    worksheetPage: number;
    worksheetFrom: number;
    worksheetTo: number;
    worksheetTotal: number;
    worksheetPageCount: number;
    worksheetPageSize: number = 25;
    worksheetAllSelected: boolean;

    showJobProgressStatus: boolean;
    progressJobID: string;
    jobTitle: string;
    progressStatus: string;

    associateSearchModalOpen: boolean;
    associateSearchCharTypeID: number;
    associateSearchCanCreate: boolean;
    associableCharTypes: { [generation: number]: { [charTypeID: number]: string } };
    associableTemplates: Models.ICharacteristicTemplate[];
    associableCharTypesGen: number;

    showAssociateJobProgress: boolean;
    associateJobID: string;
    associateTitle: string;
    associateProgressStatus: string;
    mode: string;
    exportUrl: string;

    constructor(private $scope: ng.IScope,
        private $filter: ng.IFilterService,
        private $timeout: ng.ITimeoutService,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private reportService: ReportService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private contractService: ContractService,
        private storage: StorageService,
        private rightsFilterService: RightsFilterService) {


        this.worksheetID = this.GetWorksheetID();

        this.rows = [];
        this.loading = false;
        this.SetupParameters();

        this.searchPage = 1;
        this.searchFrom = this.searchTo = this.searchTotal = this.searchPageCount = 0;
        this.selectedAssetIDs = {};
        this.selectedRows = [];

        this.selectedWorksheetAssetIDs = {};
        this.searchAllSelected = false;
        this.searchSortDir = 0;
        this.searchSortField = "";
        this.worksheetRows = [];
        this.worksheetPage = 1;
        this.worksheetFrom = this.worksheetTo = this.worksheetTotal = this.worksheetPageCount = 0;
        this.worksheetAllSelected = false;
        this.selectedWorksheetAssetIDs = {};
        this.selectedWorksheetRows = [];

        this.showJobProgressStatus = false;
        this.progressJobID = null;
        this.jobTitle = null;
        this.progressStatus = null;

        this.associateSearchModalOpen = false;
        this.associateSearchCharTypeID = 4;
        this.associateSearchCanCreate = true;

        this.showAssociateJobProgress = false;
        this.associateJobID = null;
        this.associateTitle = null;
        this.associateProgressStatus = null;

        this.associableCharTypes = {};
        this.associableTemplates = [];
        this.associableCharTypesGen = 1;
        this.mode = "1";
        this.exportUrl = "/api/report/ExportCatalogAvailabilityProperties";

        this.$scope.$watch(() => this.searchPageSize,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.searchPage == 1) {
                        this.Search();
                    } else {
                        this.searchPage = 1;
                    }
                }
            });

        this.$scope.$watch(() => this.searchPage,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.Search();
                }
            });

        this.$scope.$watchGroup<[string, number]>([() => this.searchSortField, () => this.searchSortDir],
            (newValue, oldValue) => {
                if (!angular.equals(newValue, oldValue)) {
                    this.Search();
                }
            });

        this.$scope.$watchCollection(() => this.selectedRows,
            (newValue, oldValue) => {
                if (newValue.length < oldValue.length) {
                    this.searchAllSelected = false;
                }

                this.selectedAssetIDs = {};
                this.selectedRows.forEach((row) => this.selectedAssetIDs[row.recordID] = true);
            });

        this.$scope.$watch(() => this.worksheetPageSize,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.worksheetPage == 1) {
                        this.GetWorksheetRows();
                    } else {
                        this.worksheetPage = 1;
                    }
                }
            });

        this.$scope.$watch(() => this.worksheetPage,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    this.GetWorksheetRows();
                }
            });

        this.$scope.$watchCollection(() => this.selectedWorksheetRows,
            (newValue, oldValue) => {
                if (newValue.length < oldValue.length) {
                    this.worksheetAllSelected = false;
                }
                this.selectedWorksheetAssetIDs = {};
                this.selectedWorksheetRows.forEach((row) => this.selectedWorksheetAssetIDs[row.recordID] = true);
            });

        this.$scope.$watchCollection(() => _.unique(this.selectedWorksheetRows.map(row => row.templateID)),
            (newValue, oldValue) => {
                var thisGen = ++this.associableCharTypesGen;
                this.UpdateAssociableCharTypes(thisGen);
            });

        //this.$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
        //    if (newValue != oldValue) {
        //        oldValue = 
        //    }
        //});

        this.GetWorksheetRows();
    }

    Init() {
        //this.$timeout(() => {
        //    this.associateSearchModalOpen = true;
        //}, 300);
    }

    GetWorksheetID() {
        var worksheetID = this.storage.get(this.worksheetIDKey);
        if (!worksheetID) {
            worksheetID = uuid.v4();
            this.storage.set(this.worksheetIDKey, worksheetID);
        }
        return worksheetID;
    }

    SetupParameters() {
        // start date defaults to today
        var startDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .format("L");
        // end date defaults to a year after today
        var endDate = moment()
            .subtract(moment.duration({ 'months': 1 }))
            .add(moment.duration({ 'years': 1 }))
            .format("L");

        this.filterModel = this.rightsFilterService.GetCachedFilter({
            startDate: startDate,
            endDate: endDate,
            exactInd: "0",
            exclusive: "1",
            isWindowed: false,
            selectedChannelIDs: [],
            selectedAssetFacet: {},
            selectedLanguageIDs: [],
            selectedMediaIDs: [],
            selectedTerritoryIDs: [],
            selectedRightSetTemplateIDs: [],
            show: {},
            rollup: 0,
            selectedAssetRecordIDs: [],
            matchType: 1,
            dimFormat: { "1": true, "2": true, "3": true, "4": true }
        });
    }

    Search() {
        var clientStartDate = this.filterModel.startDate;
        var clientEndDate = this.filterModel.endDate;

        //Get the user's date format and then turn it back into mm/dd/yyyy
        var dateFormat: string = moment.localeData()["_longDateFormat"]["L"];
        var startDate = moment(clientStartDate, dateFormat).format('MM/DD/YYYY')
        var endDate = moment(clientEndDate, dateFormat).format('MM/DD/YYYY')

        var assetFacets = this.filterModel.selectedAssetFacet;
        var exclusive = this.filterModel.exclusive == "" ? true : this.filterModel.exclusive == "1";
        var exactInd = _.parseInt(this.filterModel.exactInd);
        var isWindowed = this.filterModel.isWindowed;
        var territoryIDs = this.filterModel.selectedTerritoryLeafIDs;
        var mediaIDs = this.filterModel.selectedMediaLeafIDs;
        var channelIDs = this.filterModel.selectedChannelLeafIDs;
        var languageIDs = this.filterModel.selectedLanguageLeafIDs;
        var assetIDs = this.filterModel.selectedAssetRecordIDs;
        var minDays = this.filterModel.minDays;
        var matchType = this.filterModel.matchType;

        var start = (this.searchPage - 1) * this.searchPageSize;

        this.loading = true;
        this.notifyService.startProgress();
        this.reportService.getCatalogAvailsItems(startDate, endDate, assetIDs, assetFacets, exclusive, exactInd, isWindowed, territoryIDs, mediaIDs, channelIDs, languageIDs, minDays, matchType, start, this.searchPageSize, this.searchSortField, this.searchSortDir)
            .then((result) => {
                return this.reportService.getBackgroundReportResults<Models.AdvancedSearchResult>(result.reportID)
                    .then((data) => {
                        if (this.searchAllSelected) {
                            this.selectedRows = this.selectedRows.concat(data.documents);
                        }

                        this.rows = data.documents;
                        this.searchTotal = data.numFound;
                        this.searchFrom = (this.searchPage - 1) * this.searchPageSize + 1;
                        this.searchTo = Math.min(this.searchFrom + this.searchPageSize - 1, this.searchTotal);
                        this.searchPageCount = Math.ceil(data.numFound / this.searchPageSize);
                    })
                    .catch((reason) => {
                        this.notifyService.notifyError(reason);
                    });
            })
            .finally(() => {
                this.loading = false;
                this.notifyService.endProgress();
            });
    }

    Clear() {
        this.selectedRows = [];
        this.rows = [];
        this.searchTotal = 0;
        this.searchPage = 1;
        this.searchFrom = (this.searchPage - 1) * this.searchPageSize + 1;
        this.searchTo = Math.min(this.searchFrom + this.searchPageSize - 1, this.searchTotal);
        this.searchPageCount = 0;
    }

    SearchSelectAll($event: ng.IAngularEvent) {
        this.SearchSelectPage($event);
        this.searchAllSelected = true;
    }

    SearchSelectPage($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.rows.forEach((row) => {
            if (!_.any(this.selectedRows, (row2) => row2.recordID == row.recordID)) {
                this.selectedRows.push(row);
            }
        });

    }

    SearchUnselectAll($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.selectedRows = [];
        this.searchAllSelected = false;
    }

    SearchUnselectPage($event: ng.IAngularEvent) {
        $event.preventDefault();
        _.remove(this.selectedRows, (row: Models.IEntitySearchDoc) => _.any(this.rows, (row2: Models.IEntitySearchDoc) => row.recordID == row2.recordID));
        this.searchAllSelected = false;
    }

    AddToWorksheet($event: ng.IAngularEvent) {
        $event.preventDefault();
        if (this.searchAllSelected) {
            var startDate = this.filterModel.startDate;
            var endDate = this.filterModel.endDate;
            var assetFacets = this.filterModel.selectedAssetFacet;
            var exclusive = this.filterModel.exclusive == "" ? true : this.filterModel.exclusive == "1";
            var exactInd = _.parseInt(this.filterModel.exactInd);
            var isWindowed = this.filterModel.isWindowed;
            var territoryIDs = this.filterModel.selectedTerritoryLeafIDs;
            var mediaIDs = this.filterModel.selectedMediaLeafIDs;
            var channelIDs = this.filterModel.selectedChannelLeafIDs;
            var languageIDs = this.filterModel.selectedLanguageLeafIDs;
            var assetIDs = this.filterModel.selectedAssetRecordIDs;
            var minDays = this.filterModel.minDays;
            var matchType = this.filterModel.matchType;

            this.notifyService.startProgress();
            this.reportService.addAssetSearchToCatalogAvailsWorksheet(this.worksheetID, startDate, endDate, assetIDs, assetFacets, exclusive, exactInd, isWindowed, territoryIDs, mediaIDs, channelIDs, languageIDs, minDays, matchType)
                .then((result) => {
                    this.progressJobID = result.jobID;
                    this.jobTitle = "Adding To Worksheet";
                    this.showJobProgressStatus = true;
                    this.notifyService.notifySuccess("Adding to Worksheet");
                }, this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            var assetIDs = this.selectedRows.map((row) => row.recordID);
            this.notifyService.startProgress();
            this.reportService.addAssetsToWorksheet(this.worksheetID, assetIDs)
                .then(() => {
                    this.notifyService.notifySuccess("Added to Worksheet");
                    return this.GetWorksheetRows();
                },
                    this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    GetWorksheetRows() {
        var start = (this.worksheetPage - 1) * this.worksheetPageSize;

        this.notifyService.startProgress();
        return this.reportService.getCatalogAvailsWorksheetRows(this.worksheetID, this.worksheetPageSize, start)
            .then((result) => {

                if (this.worksheetAllSelected) {
                    this.selectedWorksheetRows = this.selectedWorksheetRows.concat(result.documents);
                }

                this.worksheetRows = result.documents;
                this.worksheetTotal = result.rowCount;
                this.worksheetFrom = (this.worksheetPage - 1) * this.worksheetPageSize + 1;
                this.worksheetTo = Math.min(this.worksheetFrom + this.worksheetPageSize - 1, this.worksheetTotal);
                this.worksheetPageCount = Math.ceil(result.rowCount / this.worksheetPageSize);
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    WorksheetSelectAll($event: ng.IAngularEvent) {
        this.WorksheetSelectPage($event);
        this.worksheetAllSelected = true;
    }

    WorksheetSelectPage($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.worksheetRows.forEach((row) => {
            if (!_.any(this.selectedWorksheetRows, (row2) => row2.recordID == row.recordID)) {
                this.selectedWorksheetRows.push(row);
            }
        });
    }

    WorksheetUnselectAll($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.selectedWorksheetRows = [];
        this.worksheetAllSelected = false;
    }

    WorksheetUnselectPage($event: ng.IAngularEvent) {
        $event.preventDefault();
        _.remove(this.selectedWorksheetRows, (row: Models.IEntitySearchDoc) => _.any(this.worksheetRows, (row2: Models.IEntitySearchDoc) => row.recordID == row2.recordID));
        this.worksheetAllSelected = false;
    }

    WorksheetRemoveSelected($event: ng.IAngularEvent) {
        $event.preventDefault();
        var assetIDs = this.selectedWorksheetRows.map((row) => row.recordID);
        this.notifyService.startProgress();
        this.reportService.removeAssetsFromCatalogAvailsWorksheet(this.worksheetID, assetIDs, false)
            .then(() => {
                this.notifyService.notifySuccess("Removed from Worksheet");
                this.worksheetPage = 1;
                this.selectedWorksheetRows = [];
                return this.GetWorksheetRows();
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    WorksheetRemoveAll($event: ng.IAngularEvent) {
        $event.preventDefault();
        this.notifyService.startProgress();
        this.reportService.removeAssetsFromCatalogAvailsWorksheet(this.worksheetID, [], true)
            .then(() => {
                this.notifyService.notifySuccess("Removed from Worksheet");
                this.worksheetPage = 1;
                this.selectedWorksheetRows = [];
                return this.GetWorksheetRows();
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    AssociateToEntity(document: Models.IEntitySearchDoc) {
        var count = this.worksheetAllSelected ? this.worksheetTotal : this.selectedWorksheetRows.length;
        if (this.$window.confirm(`Associate ${count} titles to ${document.title}?`)) {
            var assetIDs = [];
            if (!this.worksheetAllSelected) {
                assetIDs = this.selectedWorksheetRows.map(doc => doc.entityID);
            }
            this.notifyService.startProgress();
            this.reportService.associateChildEntitiesToParentEntity(document.entityID, this.worksheetID, assetIDs, this.worksheetAllSelected)
                .then((result) => {
                    this.associateSearchModalOpen = false;
                    this.associateTitle = `Associating ${count} titles to ${document.title}`;
                    this.associateJobID = result.jobID;
                    this.showAssociateJobProgress = true;

                }, this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    AssociateToTemplate(template: Models.ICharacteristicTemplate) {
        var count = this.worksheetAllSelected ? this.worksheetTotal : this.selectedWorksheetRows.length;
        if (this.$window.confirm(`Associate ${count} titles to a new ${template.templateName}?`)) {
            var assetIDs = [];
            if (!this.worksheetAllSelected) {
                assetIDs = this.selectedWorksheetRows.map(doc => doc.entityID);
            }
            this.notifyService.startProgress();
            this.reportService.associateChildEntitiesToNewParentEntity(Utils.IdBuilder.buildTemplateID(0, this.associateSearchCharTypeID, template.templateID), this.worksheetID, assetIDs, this.worksheetAllSelected)
                .then((result) => {
                    this.associateSearchModalOpen = false;
                    this.associateTitle = `Associate ${count} titles to a new ${template.templateName}`;
                    this.associateJobID = result.jobID;
                    this.showAssociateJobProgress = true;

                }, this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    SearchForAssociation($event: ng.IAngularEvent, charTypeID: number) {
        $event.preventDefault();
        this.associateSearchCharTypeID = charTypeID;

        var assetTemplateIDs = [];
        var worksheetID = null;
        if (this.worksheetAllSelected) {
            worksheetID = this.worksheetID;
        } else {
            assetTemplateIDs = _.unique(this.selectedWorksheetRows.map((row) => row.templateID));
        }
        this.notifyService.startProgress();
        this.reportService.getCatalogAvailsAssociableParentTemplates(this.associateSearchCharTypeID, assetTemplateIDs, worksheetID)
            .then((result) => {
                this.associableTemplates = result;
                this.associateSearchModalOpen = true;
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            });

    }

    UpdateAssociableCharTypes(generation: number) {
        var assetTemplateIDs = [];
        var worksheetID = null;
        if (this.worksheetAllSelected) {
            worksheetID = this.worksheetID;
        } else {
            assetTemplateIDs = _.unique(this.selectedWorksheetRows.map((row) => row.templateID));
        }
        this.notifyService.startProgress();
        return this.reportService.getCatalogAvailsAssociableParentCharTypes(assetTemplateIDs, worksheetID)
            .then((result) => {
                this.associableCharTypes[generation] = result;
            }, this.notifyService.errorResponseHandler)
            .finally(() => {
                this.notifyService.endProgress();
            })

    }

    GetExport() {
        var query = {
            exactInd: _.parseInt(this.filterModel.exactInd),
            startDate: this.filterModel.startDate,
            endDate: this.filterModel.endDate,
            territoryIds: this.filterModel.selectedTerritoryLeafIDs,
            mediaIds: this.filterModel.selectedMediaLeafIDs,
            channelIds: this.filterModel.selectedChannelLeafIDs,
            languageIds: this.filterModel.selectedLanguageLeafIDs,
            templateIds: "",
            exclusive: this.filterModel.exclusive == "" ? 1 : _.parseInt(this.filterModel.exclusive),
            assetIDs: this.filterModel.selectedAssetRecordIDs,
            assetFacets: this.filterModel.selectedAssetFacet,
            rollup: this.filterModel.rollup,
            minDays: this.filterModel.minDays,
            matchType: this.filterModel.matchType
        };

        this.notifyService.startProgress(); // start progress bar
        this.reportService.ExportCatalogAvailabilityProperties(query)
            .then((result) => {
                alert("An email with a link to download this export has been sent to your email address.");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    GetQueryString(object: any) {
        var queryString = "";
        for (var key in object) {

            var value = "";
            var objValue = object[key];
            if (objValue == undefined || _.isNaN(objValue)) {
                value = "";
            } else if (_.isArray(objValue)) {
                value = object[key];
            } else if (_.isObject(objValue)) {
                value = JSON.stringify(objValue);
            } else {
                value = objValue;
            }

            if (queryString == "") {
                queryString += "?" + key + "=" + value;
            }
            else {
                queryString += "&" + key + "=" + value;
            }
        }
        return queryString;
    }
}
